import React from 'react';
import { withRouter } from 'react-router-dom';
import VideoInfoModule from 'components/templates/videoInfoModule';
import { StringUtil } from 'utils/StringUtil';
// eslint-disable-next-line
import styles from "./styles.scss";

const WorkingAtTotalEnvironment = props => {
  const { heading, sub_heading, paragraph, video, video_thumbnail_url } =
    props.data && props.data.data.workingAtTESectionData;

  const content = StringUtil.formatDescription(paragraph, 25);

  function extractVideo() {
    return { __html: video };
  }

  return (
    <div className={'working-at-TE'}>
      <VideoInfoModule
        heading={heading}
        subHeading={sub_heading}
        content={content}
        videoData={extractVideo()}
        videoThumbnailUrl={video_thumbnail_url}
        onClick={() => {}}
      />
    </div>
  );
};

export default withRouter(WorkingAtTotalEnvironment);
